import { useSyncExternalStore } from 'react';
import type { Registry, RegistryEntry } from '../lib/registry';

/** Re-renders when entries are (un)registered. */
export function useRegistry<T extends RegistryEntry>(reg: Registry<T>): readonly T[] {
  return useSyncExternalStore(reg.subscribe, reg.list, reg.list);
}
